/* Kidzoo storefront behaviour — sliders, drawer, search, cart, wishlist, countdown */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var WISH_KEY = 'kz_wishlist';

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(html, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'kz kz-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.className = 'kz kz-toast' + (isError ? ' kz-toast--err' : '');
    toastEl.innerHTML = html;
    void toastEl.offsetWidth;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 4500);
  }

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-kz-cart-count]').forEach(function (e) { e.textContent = n; e.hidden = !n; });
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); })
      .catch(function () {});
  }
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10) || 1;
    btn.disabled = true;
    btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        toast('<span>Added to cart ✔</span> <a href="/cart">View cart</a> <a href="/checkout">Checkout</a>');
        refreshCount();
      })
      .catch(function (e) { toast(e.message || 'Something went wrong', true); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-busy'); });
  }

  /* ---------- wishlist (localStorage) ---------- */
  function getWish() { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch (e) { return []; } }
  function setWish(list) { try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {} paintWish(); }
  function paintWish() {
    var list = getWish();
    $$('[data-kz-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-kz-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-kz-wish-count]').forEach(function (e) { e.textContent = list.length; e.hidden = !list.length; });
  }
  function toggleWish(handle) {
    var list = getWish(), i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); }
    else { list.push(handle); toast('Saved to wishlist ♥ <a href="/pages/wishlist">View wishlist</a>'); }
    setWish(list);
  }

  /* ---------- generic slider (sliding track w/ drag + seamless loop, or fade fallback) ---------- */
  function initSlider(root) {
    if (root.__kz) return; root.__kz = 1;
    var slides = $$('[data-kz-slide]', root), dots = $$('[data-kz-dot]', root);
    var track = $('[data-kz-track]', root);
    var n = slides.length, i = 0, pos = 0, timer, endTimer, delay = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    if (!n) return;
    var canPlay = function () { return delay > 0 && n > 1; };

    function paint() {
      i = ((pos % n) + n) % n;
      slides.forEach(function (s, j) {
        var on = j === i;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }

    var clone = null;
    if (track && n > 1) {
      /* extra copy of slide 1 at the end so autoplay always moves right-to-left */
      clone = slides[0].cloneNode(true);
      clone.removeAttribute('data-kz-slide');
      clone.removeAttribute('data-shopify-editor-block');
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      track.appendChild(clone);
    }

    function setX(p, animate) {
      if (!track) return;
      if (!animate) track.classList.add('is-drag');
      track.style.transform = 'translate3d(' + (-p * 100) + '%,0,0)';
      if (!animate) { void track.offsetWidth; track.classList.remove('is-drag'); }
    }
    function settle() { /* jump from the end-clone back to the real first slide, invisibly */
      clearTimeout(endTimer);
      if (track && pos === n) { pos = 0; setX(0, false); paint(); }
    }
    function go(p) {
      if (!track) {
        pos = (p + n) % n; paint(); return;
      }
      settle();
      if (p < 0) { pos = n; setX(n, false); p = n - 1; }
      if (p > n) p = n;
      pos = p; setX(p, true); paint();
      if (p === n) {
        var ms = (parseFloat(getComputedStyle(track).transitionDuration) || 0.5) * 1000;
        endTimer = setTimeout(settle, ms + 40);
      }
    }

    function stop() { clearInterval(timer); }
    function play() { stop(); if (canPlay()) timer = setInterval(function () { go(pos + 1); }, delay); }

    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); play(); }); });
    $$('[data-kz-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(pos - 1); play(); }); });
    $$('[data-kz-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(pos + 1); play(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);

    if (track) {
      /* drag / swipe with mouse, touch or pen — the slide follows the finger */
      var sx = null, sy = 0, dx = 0, w = 0, moved = false, pid = null, suppress = false;
      root.addEventListener('pointerdown', function (e) {
        if (n < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
        if (e.target.closest && e.target.closest('.kz-dots')) return;
        settle();
        sx = e.clientX; sy = e.clientY; dx = 0; moved = false; pid = e.pointerId; w = root.offsetWidth || 1;
      });
      root.addEventListener('pointermove', function (e) {
        if (sx === null || e.pointerId !== pid) return;
        dx = e.clientX - sx;
        if (!moved) {
          if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(e.clientY - sy)) return;
          moved = true; stop();
          track.classList.add('is-drag'); root.classList.add('is-dragging');
          try { root.setPointerCapture(pid); } catch (err) {}
        }
        track.style.transform = 'translate3d(' + (-pos * w + dx) + 'px,0,0)';
      });
      var endDrag = function (e) {
        if (sx === null || (e && e.pointerId !== pid)) return;
        var d = dx, m = moved; sx = null;
        track.classList.remove('is-drag'); root.classList.remove('is-dragging');
        try { root.releasePointerCapture(pid); } catch (err) {}
        if (m) {
          suppress = true; setTimeout(function () { suppress = false; }, 0);
          if (Math.abs(d) > Math.max(50, w * 0.12)) go(d < 0 ? pos + 1 : pos - 1); else go(pos);
          play();
        }
      };
      root.addEventListener('pointerup', endDrag);
      root.addEventListener('pointercancel', endDrag);
      root.addEventListener('click', function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); } }, true);
      root.addEventListener('dragstart', function (e) { e.preventDefault(); });
      window.addEventListener('resize', function () { setX(pos, false); });
    } else {
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx2 = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx2) > 45) { go(dx2 < 0 ? pos + 1 : pos - 1); play(); }
      });
    }
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') go(pos - 1);
      if (e.key === 'ArrowRight') go(pos + 1);
    });
    /* theme editor: pause while a slide is selected for editing, resume after */
    document.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target); if (idx > -1) { go(idx); stop(); }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (slides.indexOf(e.target) > -1) play();
    });
    paint(); play();
  }

  /* ---------- announcement rotator ---------- */
  function initRotator(root) {
    if (root.__kz) return; root.__kz = 1;
    var items = $$('.kz-ann__item', root), i = 0, timer;
    if (!items.length) return;
    function go(k) { i = (k + items.length) % items.length; items.forEach(function (it, j) { it.classList.toggle('is-active', j === i); }); }
    function play() { clearInterval(timer); if (items.length > 1 && !(window.Shopify && window.Shopify.designMode)) timer = setInterval(function () { go(i + 1); }, 4500); }
    $$('[data-kz-ann-prev]', root).forEach(function (b) { b.addEventListener('click', function () { go(i - 1); play(); }); });
    $$('[data-kz-ann-next]', root).forEach(function (b) { b.addEventListener('click', function () { go(i + 1); play(); }); });
    go(0); play();
  }

  /* ---------- countdown ---------- */
  function initCountdown(el) {
    if (el.__kz) return; el.__kz = 1;
    var end = new Date(el.getAttribute('data-kz-countdown')).getTime();
    if (isNaN(end)) { el.hidden = true; return; }
    function pad(v) { return String(v).padStart(2, '0'); }
    function tick() {
      var d = Math.max(0, end - Date.now()), s = Math.floor(d / 1000);
      var map = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(map).forEach(function (k) { var t = $('[data-cd="' + k + '"]', el); if (t) t.textContent = pad(map[k]); });
      if (d === 0) { el.hidden = true; clearInterval(iv); }
    }
    var iv = setInterval(tick, 1000); tick();
  }

  /* ---------- global click handling (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    var add = t.closest('[data-kz-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }
    var wish = t.closest('[data-kz-wish]');
    if (wish) { e.preventDefault(); toggleWish(wish.getAttribute('data-kz-wish')); return; }
    var tog = t.closest('[data-kz-toggle]');
    if (tog) {
      e.preventDefault();
      var target = document.getElementById(tog.getAttribute('data-kz-toggle'));
      if (target) {
        var open = !target.classList.contains('is-open');
        target.classList.toggle('is-open', open);
        document.documentElement.classList.toggle('kz-lock', open);
        if (open) { if (target.id === 'kz-search') { var inp = $('input[type=search]', target); if (inp) setTimeout(function () { inp.focus(); }, 60); } }
      }
      return;
    }
    var close = t.closest('[data-kz-close]');
    if (close) {
      var box = close.closest('.is-open') || document.getElementById(close.getAttribute('data-kz-close'));
      if (box) { box.classList.remove('is-open'); document.documentElement.classList.remove('kz-lock'); }
      return;
    }
    if (t.closest('[data-kz-top]')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var qty = t.closest('[data-kz-qty]');
    if (qty) {
      var input = $('input', qty.parentElement);
      if (input) { var v = parseInt(input.value || '1', 10) + parseInt(qty.getAttribute('data-kz-qty'), 10); input.value = Math.max(1, v); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.kz-drawer.is-open, .kz-search.is-open').forEach(function (b) { b.classList.remove('is-open'); });
      document.documentElement.classList.remove('kz-lock');
    }
  });

  /* FAQ: keep one open at a time */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.matches && d.matches('.kz-faq details') && d.open) {
      $$('.kz-faq details', d.closest('.kz-faq')).forEach(function (o) { if (o !== d) o.open = false; });
    }
  }, true);

  /* back to top */
  function onScroll() { $$('[data-kz-top]').forEach(function (b) { b.classList.toggle('is-show', window.scrollY > 700); }); }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- wishlist page renderer ---------- */
  function initWishPage(root) {
    if (root.__kz) return; root.__kz = 1;
    var list = getWish(), grid = $('[data-kz-wish-grid]', root), empty = $('[data-kz-wish-empty]', root);
    if (!list.length) { if (empty) empty.hidden = false; return; }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (!items.length) { if (empty) empty.hidden = false; return; }
      var fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR', maximumFractionDigits: 0 });
      grid.innerHTML = items.map(function (p) {
        var img = (p.featured_image || '').replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2');
        var v = p.variants.filter(function (x) { return x.available; })[0];
        return '<article class="kz-card"><div class="kz-card__media"><a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">' : '') + '</a>' +
          '<div class="kz-card__acts"><button class="kz-fab is-on" data-kz-wish="' + p.handle + '" aria-label="Remove from wishlist"><svg class="kz-i" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.8 5.6a5.2 5.2 0 0 0-7.4 0L12 7l-1.4-1.4a5.2 5.2 0 0 0-7.4 7.4L12 21.8l8.8-8.8a5.2 5.2 0 0 0 0-7.4z"/></svg></button></div></div>' +
          '<h3 class="kz-card__title"><a href="' + p.url + '">' + p.title + '</a></h3><p class="kz-card__price">' + fmt.format(p.price / 100) + '</p>' +
          (v ? '<button class="kz-btn kz-btn--navy kz-btn--sm" data-kz-add data-variant-id="' + v.id + '">Add to cart</button>' : '<span class="kz-card__price">Sold out</span>') + '</article>';
      }).join('');
    });
  }

  function init() {
    $$('[data-kz-slider]').forEach(initSlider);
    $$('[data-kz-rotate]').forEach(initRotator);
    $$('[data-kz-countdown]').forEach(initCountdown);
    $$('[data-kz-wishpage]').forEach(initWishPage);
    paintWish(); refreshCount(); onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('storage', paintWish);
})();
